<section class="py-8 mt-2 bg-white md:py-16 dark:bg-gray-900 antialiased">
  <div class="max-w-screen-xl px-4 mx-auto 2xl:px-0">
    <div class="lg:grid lg:grid-cols-2 lg:gap-8 xl:gap-16">
      <!-- Product Image -->
      <div class="shrink-0 max-w-md lg:max-w-lg mx-auto">
        <img class="w-full" [src]="productDetails.imageUrl" [alt]="productDetails.name" />
      </div>

      <!-- Product Details -->
      <div class="mt-6 sm:mt-8 lg:mt-0">
        <h1 class="text-xl font-semibold text-gray-900 sm:text-2xl">{{ productDetails.name }}</h1>
        <div class="mt-4 sm:flex sm:items-center sm:gap-4">
          <p class="text-2xl font-extrabold text-gray-900 sm:text-3xl">Dinar {{ productDetails.price }}</p>
          <!-- Product Rating -->
          <div class="flex items-center gap-2 mt-2 sm:mt-0">
            <!-- Full 5-star rating using SVG icons -->
            <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
              <svg class="w-4 h-4 text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z"/>
              </svg>
            </ng-container>
            <p class="text-sm font-medium leading-none text-gray-500 dark:text-gray-400">(5.0)</p>
          </div>
        </div>

        <!-- Add to Cart Button -->
        <div *ngIf="!isAdding && !isAdded">
          <button class="text-white mt-4 sm:mt-0 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" (click)="toggleAdding()">
            Add to cart
          </button>
        </div>

        <!-- Quantity Input and Save Button -->
        <div *ngIf="isAdding">
          <div class="flex items-center">
            <button class="px-3 py-1 text-white bg-gray-700 rounded-l hover:bg-gray-800" (click)="decreaseQuantity()">-</button>
            <div class="px-4 py-1 text-center border-t border-b border-gray-300 dark:border-gray-600">{{ quantity }}</div>
            <button class="px-3 py-1 text-white bg-gray-700 rounded-r hover:bg-gray-800" (click)="increaseQuantity()">+</button>
            <button class="mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" (click)="saveAndToggleAdding()">
              Save
            </button>
          </div>
        </div>

        <!-- Done Button -->
        <div *ngIf="isAdded && !isAdding">
          <button class="text-white mt-4 sm:mt-0 bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-blue-800" (click)="toggleAdding()">
            <i class="bi bi-check-circle-fill"></i> Done
          </button>
        </div>

        <hr class="my-6 md:my-8 border-gray-200 dark:border-gray-800" />

        <p class="mb-6 text-gray-500 dark:text-gray-400">{{ productDetails.description }}</p>
      </div>
    </div>
  </div>
</section>
